import createVueApp from '@/common/createApp'

Styxie.Initializers.SubscriptionCancelations = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/subscription_cancelations/show/index.vue')
    createVueApp(ShowPage, { props, layout: null })
  }
}
